window.ME_COLOR_LIBRARY = {
  "af-apparel": {
    "baby-pink": "#f3b6c8",
    "black": "#111111",
    "burgundy": "#5f1d2d",
    "camo": "#5f6348",
    "charcoal": "#3f3f3f",
    "charcoal-heather": "#555555",
    "coral": "#f06f61",
    "dark-navy": "#18233a",
    "decadent-chocolate": "#4a2f26",
    "denim": "#4f6f8f",
    "dust": "#cfc3b7",
    "dust-pm": "#cfc3b7",
    "gold": "#f2b233",
    "hot-pink": "#e83e8c",
    "kelly-green": "#237a45",
    "lavender": "#b9a6d3",
    "lime-green": "#8cc63f",
    "maroon": "#672e45",
    "military-green": "#4b5435",
    "mint": "#a8d5ba",
    "moss-green": "#59633f",
    "mustard": "#c6973f",
    "navy": "#1f2a44",
    "neon-orange": "#ff671f",
    "neon-yellow": "#ecf166",
    "oatmeal-heather": "#d1ccbd",
    "orange": "#ff6a39",
    "pacific-blue": "#3c8fb5",
    "peach": "#f3be8d",
    "pink": "#f7ced7",
    "powder-blue": "#b8d7e8",
    "pure-navy": "#1b2440",
    "purple": "#5b3f86",
    "red": "#e10600",
    "royal": "#24509a",
    "royal-am": "#24509a",
    "rust": "#9e483f",
    "salt-pepper": "#8d8a84",
    "sand": "#d8c3a5",
    "sawana-brown": "#8a5f3f",
    "sports-grey": "#b8b8b8",
    "sport-grey": "#b8b8b8",
    "teal": "#007f7a",
    "texas-orange": "#bf5700",
    "turquoise": "#40b5ad",
    "white": "#ffffff",
    "yellow": "#f1c84b"
  }
};